import { MapParams } from '@/api/endpoints/map/map.types';
import { FilterDataType } from '@/enums/FilterDataType.enum';

/**
 *  This model is used like filter and only sets proper params for BE
 */
export class MapFiltersReqModel implements MapParams {
  public author: string;
	public variable?: string;
	public period?: string;
	public dataType: FilterDataType;
  public gwl?: string;
	public scenario?: string;
	public season?: string;
	public gridSpacing?: string;


	constructor(obj: MapParams) {
    this.author = obj.author;
		this.dataType = obj.dataType;
		this.variable = obj.variable;
		this.period = obj.period;
    this.gwl = obj.gwl;
		this.scenario = obj.scenario;
		this.season = obj.season;
		this.gridSpacing = obj.gridSpacing;
	}
}
